import { RouteConfig } from 'vue-router'
import i18n from '@/i18n'

const routes: Array<RouteConfig> = [
    {
        path: '/error',
        name: 'error',
        meta: { title: i18n.t('integration') },
        component: () => import('@/modules/error/views/ErrorComponent.vue')
    }
]

export default routes
